const getters = {
  custObj: state => state.user
}

export default getters
